import { render, staticRenderFns } from "./mypageIndex.vue?vue&type=template&id=cf24ce8c"
import script from "./mypageIndex.vue?vue&type=script&lang=ts"
export * from "./mypageIndex.vue?vue&type=script&lang=ts"
import style0 from "./mypageIndex.vue?vue&type=style&index=0&id=cf24ce8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports